import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M19.3536 6.0464C19.5488 5.85114 19.5488 5.53456 19.3536 5.33929L18.6607 4.6464C18.4654 4.45114 18.1488 4.45114 17.9536 4.6464L12 10.6L6.04646 4.6464C5.8512 4.45114 5.53462 4.45114 5.33935 4.6464L4.64646 5.33929C4.4512 5.53456 4.4512 5.85114 4.64646 6.0464L10.6 12L4.64646 17.9535C4.4512 18.1488 4.4512 18.4654 4.64646 18.6606L5.33935 19.3535C5.53462 19.5488 5.8512 19.5488 6.04646 19.3535L12 13.4L17.9536 19.3535C18.1488 19.5488 18.4654 19.5488 18.6607 19.3535L19.3536 18.6606C19.5488 18.4654 19.5488 18.1488 19.3536 17.9535L13.4 12L19.3536 6.0464Z"
    fillRule="evenodd"
  />,
  'CrossLarge',
)
